import * as yup from "yup";

export const calculatorSchema = yup.object().shape({
    location: yup.string()
        .min(1, "Distrito requerido")
        .max(100, "Distrito Inválido")
        .required("Distrito requerido"),
    squareMeters: yup.string().required("M2 requerido"),
    housingType: yup.string().required("Tipo de vivienda requerida"),
});
